import React from "react";
import moment from "moment";
import './style.css';
import { constants } from "../../Constants";

const ProjectSelectionModal = ({ projects, selectedProjects, dateTime, state }) => {
    const isAllSelected = projects.every((p) => selectedProjects.includes(p.name));
    const selectedDate = moment(dateTime).format("YYYY-MM-DD");
    const selectedHour = moment(dateTime).format("HH:mm");

    const timeOptions = [];
    for (let hour = 0; hour < 24; hour++) {
        const formattedHour = hour.toString().padStart(2, "0");
        timeOptions.push(`${formattedHour}:00`);
    }

    const calculateLastPageSlots = () => {
        const hoursRequred = 23;
        const daysHours = [];
        var d = new Date();
        var n = d.getHours();
        const hours = [];
        const startingPoint = 22;
        const daysRequired = 28;

        for (let v = startingPoint; v <= daysRequired; v++) {
            for (let i = 0; i <= hoursRequred; i++) {
                const obj = {
                    hour: moment().add(i, 'hour').add(v, 'days').subtract(n, 'hours').format('YYYY-MM-DD HH:00:00'),
                };

                hours.push(obj);
            }
            daysHours.push(hours.slice(hours.length - 24, hours.length));
        }
        return daysHours;
    };
    const min = [...state['one']][0][0].hour;
    const max = calculateLastPageSlots()[6][23].hour;

    return (
        <div className="content-container">
            <p className="schedule-text">{constants.SELECTED_SCHEDULE_TXT}</p>
            <div className="date-project-list-container">
                <div className="date-time-select-container">
                    <div id="datePickerWrapper" className="date-time-wrapper">
                        <input
                            type="date"
                            id="datePicker"
                            className="date-time-feild"
                            min={moment(min).format("YYYY-MM-DD")}
                            max={moment(max).format("YYYY-MM-DD")}
                            value={selectedDate}
                            title=""
                        />
                    </div>

                    <div id="timePickerWrapper" className="date-time-wrapper">
                        <select
                            id="timePicker"
                            className="date-time-feild"
                            type="time"
                            value={selectedHour}
                        >
                            {timeOptions.map((option) => (
                                <option key={option} value={option}>
                                    {option}
                                </option>
                            ))}
                        </select>
                    </div>

                </div>

                <div className="projects-container">
                    <div className="selectAllContainer">
                        <input
                            type="checkbox"
                            id="selectAllCheckbox"
                            checked={isAllSelected}
                        />
                        <label htmlFor="selectAllCheckbox" id="selectAllLabel">
                            {isAllSelected ? "Unselect All" : "Select All"}
                        </label>
                    </div>
                    <div className="project-list-container">
                        {projects.map((p) => (
                            <div key={p.id} className="project-list-item">
                                <input
                                    type="checkbox"
                                    checked={selectedProjects.includes(p.name)}
                                    className="hidden popup-project-checkbox"
                                    name={p.name}
                                    id={`project-${p.id}`}
                                    data-project-id={p.id}
                                    data-project-name={p.name}
                                />
                                <label className="popup-project-label my-label" htmlFor={`project-${p.id}`}>
                                    {p.name}
                                </label>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProjectSelectionModal;



// WEBPACK FOOTER //
// ./src/components/RegisterSlotUpdateModal/index.js